export default "__VITE_ASSET__BjpCR23X__"